import React, { createContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState(() => {
        return localStorage.getItem("token") ? JSON.parse(localStorage.getItem("token")) : null;
    });

    const login = (token) => {
        localStorage.setItem("token", JSON.stringify(token))
        setAuth(token)
    }

    const logout = () => {
        localStorage.removeItem("token");
        setAuth(null);
    };

    return (
        <AuthContext.Provider value={{ auth, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;